
export class Attachment {
blobId: string;
businessUnitCode: string;
bytes: string;
connectForceDirectory: boolean;
connectUsage: boolean;
createTime: number | null;
directory: string;
domain: string;
fileContent: string;
fileName: string;
fileSize: number;
fileType: string;
metadatas: {[key: string]: string};
rootDirectory: string;
thumb: boolean;
v2: boolean;
vision: string;
}

